module.exports = __webpack_public_path__ + "static/OCRA-79262b0a5a8311b6d91d3125b8cea5cd.woff";